import { render, staticRenderFns } from "./ControlBase.vue?vue&type=template&id=63857705&scoped=true"
import script from "./ControlBase.vue?vue&type=script&lang=js"
export * from "./ControlBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63857705",
  null
  
)

export default component.exports